import {LOGIN_FAIL, LOGIN_LOADING, LOGIN_SUCCESS, LOGOUT_USER, TRAVERSING_FAIL, TRAVERSING_IN_FAIL, TRAVERSING_IN_LOADING, TRAVERSING_IN_SUCCESS, TRAVERSING_LOADING, TRAVERSING_SUCCESS } from "../Components/Constants/ActionTypes";
import AxiosHelper from "../Helpers/AxiosHelper";
import { ReactSession } from 'react-client-session';
import { RemoveAllLocalData, UpdateLocalAccessToken, UpdateLocalPermission, UpdateLocalProfile, UpdateLocalRoutes, UpdateLocalSubmenus, UpdateUserProfile } from "../Helpers/TokenServices";

ReactSession.setStoreType("sessionStorage");


export const UserLogin =  ({password,email}) => (dispatch)=>{

    dispatch({
        type:LOGIN_LOADING,
    });

    AxiosHelper.post('/users/login',{email,password}).then(
        (res) => {
            //Destructure of an object
            const {status,message,permittedRoutes,permissionList,permittedSubmenus,profile_route} = res.data;

            if(status !== 'Failed'){
                //Saving data to the local storage
                UpdateLocalProfile(res.data.data)

                //Update the localstorage
                UpdateLocalAccessToken({
                    token:res?.data?.token,
                    tokenExpiresIn:res?.data?.tokenExpiresIn});
                //Save the permitted routes list the local storage
                UpdateLocalRoutes(permittedRoutes)
                //Save the permissions list the local storage
                UpdateLocalPermission(permissionList)
                //Save the submenus list the local storage
                UpdateLocalSubmenus(permittedSubmenus);
                // Local profile for user to backoffice
                UpdateUserProfile(profile_route);

                dispatch({
                    type:LOGIN_SUCCESS,
                    payload:res.data,
                });

            }else{

                dispatch({
                    type:LOGIN_FAIL,
                    payload:message,
                });
            }
            
        }
    ).catch(
        (err) => {

            if(err.code === 'ERR_NETWORK'){
                dispatch({
                    type:LOGIN_FAIL,
                    payload:{
                        'status':'Failed',
                        'message':'Server is not available or check your internet connection'},
                });
            }else if(err.code === 'ERR_BAD_REQUEST'){

                dispatch({
                    type:LOGIN_FAIL,
                    payload:{
                        'status':'Failed',
                        'message':err?.response?.data?.message},
                });

            }else{
                dispatch({
                    type:LOGIN_FAIL,
                    payload:err?.response?.data,
                });
            }
        }
    )


}

export const UserLogout =()=> (dispatch)=>{
    //Remove the localstorage
    RemoveAllLocalData();

    dispatch({
        type:LOGOUT_USER,
    })

}

export const getDoctorsByNames = async (names)=>{
    try {
        const res = await AxiosHelper.get(`/users/select2/doctors/${names}`);
        return res.data;
    } catch (err) {
        return [];//err.response.status;
    }
}

export const userTraversingToAct = (payload)=>(dispatch)=>(onSuccess)=>{
    
    dispatch({
        type:TRAVERSING_LOADING
    });

    AxiosHelper.post(`/users/traversingAuth`,{payload}).then(
        (res)=>{
            dispatch({
                type:TRAVERSING_SUCCESS,
                payload:res.data
            })
            onSuccess(res.data);
        }

    ).catch(
        (err)=>{
            dispatch({
                type:TRAVERSING_FAIL,
                payload:err.response.data.message,
            })
        }
    )
}

export const userTraversingFromAct = (payload)=>(dispatch)=>(onSuccess)=>{
    
    dispatch({
        type:TRAVERSING_IN_LOADING
    });

    AxiosHelper.post(`/users/traversingFromAuth`,{payload}).then(
        (res)=>{
            dispatch({
                type:TRAVERSING_IN_SUCCESS,
                payload:res.data
            })
            onSuccess(res.data);
        }

    ).catch(
        (err)=>{
            dispatch({
                type:TRAVERSING_IN_FAIL,
                payload:err.response.data.message,
            })
        }
    )
}